import React, { Component } from 'react';
import { Button, Icon, message, Modal, Upload } from 'antd';
import { httpClient } from '../../../../net/httpClient';
import UrlConfig from '../../../../net/UrlConfig';

class UploadStatementDialog extends Component {
    onUploadChange = (info) => {
        const { file } = info;
        if (file.status === 'error') {
            message.error('Upload monthly statement failed');
            return;
        }
        if (file.status !== 'done' || !file.response || !file.response.data) {
            return;
        }

        const { account, onClose, onSuccess } = this.props;
        const { fileNameWithTimeStamp, originalFileName } = file.response.data;
        httpClient.post(UrlConfig.UPLOAD_MONTHLY_STATEMENT, {
            accountId: account.id,
            fileName: fileNameWithTimeStamp,
            originalFileName,
        }).then(() => {
            message.success('Upload monthly statement succeeded');
            if (onSuccess) {
                onSuccess();
            } else {
                onClose();
            }
        }).catch((err) => {
            message.error((err && err.respMessage) || 'Upload monthly statement failed');
        });
    }

    render() {
        const { visible, onClose, account, personalAccountUploadUrl } = this.props;
        return (
            <Modal
                title="Upload Monthly Statement"
                visible={visible}
                centered
                destroyOnClose={true}
                maskClosable={false}
                onCancel={onClose}
                footer={<Button onClick={onClose}>Close</Button>}
            >
                {/* <p>Upload a monthly statement for the selected FinalApproved Personal Account.</p> */}
                {account && (
                    <div style={{ marginBottom: 16, padding: 12, background: '#fafafa', border: '1px solid #e8e8e8' }}>
                        <div><strong>Account holder:</strong> {account.accountName}</div>
                        <div><strong>Brokerage firm:</strong> {account.brokerAccount}</div>
                        <div><strong>Account No.:</strong> {account.accountNo || '-'}</div>
                    </div>
                )}
                <Upload
                    name="monthlyStatement"
                    withCredentials={true}
                    multiple={false}
                    action={personalAccountUploadUrl}
                    disabled={!account}
                    onChange={this.onUploadChange}
                >
                    <Button type="primary"><Icon type="upload" />Upload Statement</Button>
                </Upload>
            </Modal>
        );
    }
}

export default UploadStatementDialog;
